import { render, staticRenderFns } from "./AutomaticInformPayload.vue?vue&type=template&id=29af1bc8&"
import script from "./AutomaticInformPayload.vue?vue&type=script&lang=js&"
export * from "./AutomaticInformPayload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports